import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingNextToGo: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_NEXT_TO_GO: (s, data) => (s.loadingNextToGo = data),
  },

  actions: {
    async getNextToGoSport({ commit }, params) {
      commit("LOAD_NEXT_TO_GO", true);
      try {
        const { data: res } = await this.$api.get("/v1/portal/sport-events", {
          params,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_NEXT_TO_GO", false);
      }
    },
  },
};
